'use strict';



const xtend = require('xtend');
const $ = require('jquery');
const elements = {};
const fired = {};

let config = {
	dismissableClassName: 'js-dismissable',
	parentClassName: null,
	dismissClassName: 'js-dismiss',
	api: null
};



module.exports = function dismissables(userConfig) {

	config = xtend(config, userConfig);
	elements.$dismissables = $(`.${config.dismissableClassName}`);

	if(elements.$dismissables.length < 1) {
		return;
	}

	elements.$dismisses = $(`.${config.dismissClassName}`)
		.on('click', dismissThisTarget);

};



function dismiss(id, options = {}) {

	if(fired[id]) {
		return;
	}

	const $target = $(`#${id}`);
	const entryClassName = $target.data('entry-class');
	const exitClassName = $target.data('exit-class');
	let $parent;

	fired[id] = true;
	save(id, options);

	if(config.parentClassName) {
		$parent = $target.closest(`.${config.parentClassName}`);
	}

	if(options.nextUrl) {
		return;
	}

	if(exitClassName) {
		if (entryClassName) {
			$target.removeClass(entryClassName);
		}
		setTimeout(() => {
			$target.addClass(exitClassName);
		}, 1);
	} else {
		$target.remove();
	}

	if($parent && $parent.children().length < 1) {
		$parent.remove();
	}

}



function dismissThisTarget(e) {
	const targetId = $(this).data('target');
	const nextUrl = $(this).data('next-url');
	dismiss(targetId, { nextUrl });
	e.preventDefault();
}



function save(id, options = {}) {
	$.post(`${config.api}/${id}`, () => {
		if(options.nextUrl) {
			location.href = options.nextUrl;
		}
	});
}